declare global {
  interface Window {
    fbq: (...args: any[]) => void
    _fbq: (...args: any[]) => void
  }
}

export function initMetaPixel(pixelId: string) {
  if (typeof window === 'undefined') return

  // Avoid double-init
  if (window.fbq) return

  const f: any = (window.fbq = function (...args: any[]) {
    f.callMethod ? f.callMethod(...args) : f.queue.push(args)
  })

  if (!window._fbq) window._fbq = f
  f.push = f
  f.loaded = true
  f.version = '2.0'
  f.queue = []

  // Load the SDK script
  const script = document.createElement('script')
  script.async = true
  script.src = 'https://connect.facebook.net/en_US/fbevents.js'
  document.head.appendChild(script)

  // Init pixel
  window.fbq('init', pixelId)
  window.fbq('track', 'PageView')
}

export function trackEvent(eventName: string, params?: Record<string, any>) {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', eventName, params)
  }
}
